import React, { useMemo } from "react";
import Card from "../../../../componentes/contenedores/Card";
import Page from "../../../../componentes/plantilla/Page";
import { useContextEmpleado } from "../../../../contexto/empleado/EmpleadoContext";
import { useContextUsuario } from "../../../../contexto/usuario/UsuarioContext";
import Tablas from "../../../../componentes/tablas/TablasGenerico";
import ModalProveedor from "./ModalProveedor";
import EliminarProveedor from "./EliminarProveedor";
import { createRoot } from "react-dom/client";

const HomeEditarProveedores = () => {
    const { listaProveedores, setListaProveedores, ActualizarLista } = useContextEmpleado();
    const { token } = useContextUsuario();

    const datos = {
        titulo: {
            titulo: "Edicion proveedor",
            url: "/app/admin/proveedores/gestionar",
            tituloUrl: "Menu Proveedores",
            nombreUrl: "Inicio ",
        },
    };

    const columnasProveedores = useMemo(
        () => [
            { targets: 0, title: "Id", data: "id" },
            { targets: 1, title: "Nombre", data: "nombre" },
            { targets: 2, title: "RTN", data: "rtn" },
            { targets: 3, title: "Correo", data: "correo" },
            {
                targets: 4,
                title: "Opciones",
                data: null,
                orderable: false,
                searchable: false,
                className: "dt-center all", // Clase 'all' para asegurar visibilidad en responsive
                createdCell: (td, cellData, rowData) => {
                    const root = createRoot(td);
                    root.render(
                        <div style={{ display: "flex", justifyContent: "center", alignItems: "center", gap: "1em" }}>
                            <ModalProveedor
                                datos={rowData}
                                token={token}
                                setListaProveedores={setListaProveedores}
                                ActualizarLista={ActualizarLista}
                            />
                            <EliminarProveedor
                                datos={rowData}
                                token={token}
                                setListaProveedores={setListaProveedores}
                                ActualizarLista={ActualizarLista}
                            />
                        </div>
                    );
                },
            },
        ],
        [token, setListaProveedores, ActualizarLista]
    );

    return (
        <Page datos={datos}>
            <Card titulo="Datos del proveedor">
                <Tablas
                    datos={listaProveedores}
                    columnas={columnasProveedores}
                    id="tablaProveedores"
                />
            </Card>
        </Page>
    );
}

export default HomeEditarProveedores;